import { useQuery } from "@tanstack/react-query";
import { getCategorias } from "../api";


export const CategoriasList = () => {
  const query = useQuery(
    ['listarCategorias'],
    async () => getCategorias(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
      retry: false,
    },
  );

  return query;
};